import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import {
  updateShiftTemplate,
  updateLiveShift,
  setModal,
  setCalendarMultiSelect,
  setCalendar,
  deleteLiveShift,
  setCycleDetail,
  deleteCycleDetail
} from '@app/ac'
import { openedManagerAssistantPlanning } from '@app/reducer/manager-assistant'
import setCycleDetailLastSaved from '@app/ac/set-cycle-detail-last-saved'
import createShift from '@app/ac/create-shift'
import { withPlugin } from '@core/hoc/withPlugin'

const mapStateToProps = ({ auth, calendar, positions, workspaces, workspaceId, calendarMultiSelect, calendarFilters, cycleDetail }) => {
  return {
    auth,
    calendarMultiSelect,
    calendarFilters,
    calendar: calendar || {},
    positions,
    workspace: workspaces.find(ws => ws.id === workspaceId) || {},
    cycleDetail
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setModal,
    openPlanning: openedManagerAssistantPlanning,
    setCalendarMultiSelect,
    setCalendar,
    updateLiveShift,
    updateShiftTemplate,
    deleteLiveShift,
    setCycleDetail,
    deleteCycleDetail,
    setCycleDetailLastSaved,
    createShift
  }, dispatch)
}

export default (component) => {
  return compose(
    withPlugin,
    connect(mapStateToProps, mapDispatchToProps))(component)
}
